/// <amd-module name="Feed/Admin/Redux/GlobalSettings/GlobalSettingsReducers" />
import { IIdentity } from "VSS/Features/Identities/IdentityService";

import produce from "immer";

import { GlobalSettingsActions, GlobalSettingsActionTypes } from "./GlobalSettingsActions";
import { IGlobalSettingsState } from "./GlobalSettingsContracts";

export function globalSettingsReducer(
    state: IGlobalSettingsState = initialGlobalSettingsState(),
    action: GlobalSettingsActions
) {
    return produce(state, draft => {
        switch (action.type) {
            case GlobalSettingsActionTypes.LoadStarted:
                draft.isLoading = true;
                break;

            case GlobalSettingsActionTypes.LoadCompleted: {
                const { data } = action.payload;
                draft.isLoading = false;
                draft.everyoneIsCreator = data.everyoneIsCreator;
                draft.adminIds = data.adminIds;
                draft.creatorIds = data.creatorIds;
                draft.customNames = data.customNames;
                break;
            }

            case GlobalSettingsActionTypes.SavePermissions: {
                // update the state - the saga will select the data from there
                const { data } = action.payload;
                draft.everyoneIsCreator = data.everyoneIsCreator;
                draft.adminIds = data.adminIds;
                draft.creatorIds = data.creatorIds;
                draft.customNames = data.customNames;
                break;
            }

            case GlobalSettingsActionTypes.SaveStarted:
                draft.isSaving = true;
                draft.errorMessage = undefined;
                break;

            case GlobalSettingsActionTypes.SaveCompleted:
                draft.isSaving = false;
                break;

            case GlobalSettingsActionTypes.SetError:
            case GlobalSettingsActionTypes.LoadFailed:
            case GlobalSettingsActionTypes.SaveFailed:
                draft.errorMessage = action.payload.errorMessage;
                draft.isLoading = false;
                draft.isSaving = false;
                break;
        }
    });
}

export function initialGlobalSettingsState() {
    return {
        isLoading: false,
        isSaving: false,
        errorMessage: undefined,
        everyoneIsCreator: false,
        creatorIds: new Array<IIdentity>(),
        adminIds: new Array<IIdentity>(),
        customNames: new Array<string>()
    } as IGlobalSettingsState;
}
